<script setup>
import ModelDropdown from './ModelDropdown.vue';

defineProps({
  featureKey: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  isAllowed: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['change']);

const handleModelChange = ({ feature, model }) => {
  emit('change', { feature, model });
};
</script>

<!-- Phase 9.4: one setting row (words on the left, the select on the right, wrapping on a phone), not a card. -->
<template>
  <div
    class="flex flex-wrap items-center justify-between gap-x-4 gap-y-2"
    :class="{ 'pointer-events-none opacity-60': !isAllowed }"
  >
    <div class="min-w-0 flex-1 basis-48">
      <p class="type-polaris-label">{{ title }}</p>
      <p class="type-polaris-caption text-polaris-muted-foreground">
        {{ description }}
      </p>
    </div>
    <ModelDropdown
      v-if="isAllowed"
      :feature-key="featureKey"
      :label="title"
      @change="handleModelChange"
    />
  </div>
</template>
